module.exports = __webpack_public_path__ + "img/logo-m2n.b4572397.svg";